module.exports = __webpack_public_path__ + "img/excel-white-used.87b94158.svg";